var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6699 29.8145L29.8535 25.0098L21.6699 20.2051V29.8145Z",
    fill: "#939393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 0C11.1914 0 0 11.1914 0 25C0 38.8086 11.1914 50 25 50C38.8086 50 50 38.8086 50 25C50 11.1914 38.8086 0 25 0ZM37.5 29.4727C37.5 33.7793 33.1934 33.7793 33.1934 33.7793H16.8066C12.5 33.7793 12.5 29.4727 12.5 29.4727V20.5371C12.5 16.2305 16.8066 16.2305 16.8066 16.2305H33.1934C37.5 16.2305 37.5 20.5371 37.5 20.5371V29.4727Z",
    fill: "#939393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubelogo);
export default __webpack_public_path__ + "static/media/youtubelogo.8e03f570351b5fa345349eb7d18ca5b9.svg";
export { ForwardRef as ReactComponent };